"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fontSizes = void 0;
var fontSizes = [0, 4, 8, 12, 16, 20, 24, 28, 32, 36, 40, 44, 48, 52, 56, 60, 64, 68, 72, 76, 80, 84, 88];
exports.fontSizes = fontSizes;